import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ModalExcluir({ isOpen, onClose, onConfirm, Mensagem }) {
    
    if(!isOpen) return null;

    return (
        <>
            <Modal show={isOpen} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {Mensagem}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Cancelar
                    </Button>

                    <Button variant="danger" onClick={onConfirm}>
                        Deletar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ModalExcluir;
